/**
 * @generated SignedSource<<862561b6e0557a6a60daf1121c5d9c16>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ServicePageShowImage_productizedService$data = {
  readonly cover: {
    readonly " $fragmentSpreads": FragmentRefs<"ProjectCoverWrapper_portfolioProjectCover">;
  } | null;
  readonly productizedServiceId: string;
  readonly publishedAt: ContraAPIScalars.DateTime | null;
  readonly title: string;
  readonly visitorCanEdit: boolean;
  readonly " $fragmentType": "ServicePageShowImage_productizedService";
};
export type ServicePageShowImage_productizedService$key = {
  readonly " $data"?: ServicePageShowImage_productizedService$data;
  readonly " $fragmentSpreads": FragmentRefs<"ServicePageShowImage_productizedService">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ServicePageShowImage_productizedService",
  "selections": [
    {
      "alias": "productizedServiceId",
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "visitorCanEdit",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "title",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "publishedAt",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "cover",
      "plural": false,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "ProjectCoverWrapper_portfolioProjectCover"
        }
      ],
      "storageKey": null
    }
  ],
  "type": "ProductizedService",
  "abstractKey": null
};

(node as any).hash = "5740d85bb37704dda52b42448c8d6524";

export default node;
